import {BaseContainerModel} from '../base-container.model';
import { bl_fi_mst_comp_einvoice_printable_format_hdr_RowClass } from '../../dbschema/bl_fi_mst_comp_einvoice_printable_format_hdr.model';

export class CompanyEInvoicePrintableFormatHdrContainerModel extends BaseContainerModel {
  bl_fi_mst_comp_einvoice_printable_format_hdr: bl_fi_mst_comp_einvoice_printable_format_hdr_RowClass = new bl_fi_mst_comp_einvoice_printable_format_hdr_RowClass();
}
